/* eslint-disable no-unused-expressions */
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
import React, { useRef } from "react";
import "../../App.css";
import DataTable from "react-data-table-component";
import axios from "axios";
import { endpoints } from "../../services/apiurl";
import { withRouter } from "react-router";
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import moment from "moment";
import { Button, Card, TextField } from "@mui/material";
import { InfinitySpin } from "react-loader-spinner";

class FranchiseLeads extends React.Component {
  // Constructor
  constructor(props) {
    super(props);

    this.state = {
      items: [],
      DataisLoaded: false,
      restaurent: [],
      restaurent_outlet: [],
      restro_id: "",
      start_date: "",
      rest: "",
      end_date: "",
      type: "",
      currentPage: 1,
      page: 1,
      totalPages: 1,
      total: "",
      totalfranchise: 0,
      per_page: 10,
      booking_status: "",
      booking_type: "",
    };
  }

  componentDidMount() {
    this.fetchData(this.state.page, this.state.per_page);
    this.fetchRestData();
  }

  fetchData = (page, per_page, start_date, end_date, rest) => {
    let a = localStorage.getItem("user");
    let b = JSON.parse(a);
    let user_id = b.id;
    let restro_id = b.restro_id;
    rest = rest !== undefined ? rest : "";

    if (restro_id === 0) {
      restro_id = rest;
    }

    axios
      .post(endpoints.franchiseFilter, {
        start_date,
        end_date,
        restro_id,
        page,
        per_page,
      })
      .then((response) => {
        this.setState({
          items: response.data.data,
          totalfranchise: response.data.total,
          totalPages: response.data.total_pages,
          DataisLoaded: true,
          page,
          per_page,
        });
      });
  };

  handlePageChange = (page) => {
    this.fetchData(
      page,
      this.state.per_page,
      this.start_date,
      this.end_date,
      this.rest
    );
  };

  handlePerRowsChange = (newPerPage, page) => {
    this.setState({ per_page: newPerPage }, () => {
      this.fetchData(
        page,
        newPerPage,
        this.start_date,
        this.end_date,
        this.rest
      );
    });
  };

  fetchRestData() {
    let a = localStorage.getItem("user");
    let b = JSON.parse(a);

    axios.post(endpoints.getRestaurentsDropDown, {}).then((response) => {
      this.setState({
        restaurent: response.data.data,
        total: response.data.total,
        totalPages: response.data.total_pages,
        DataisLoaded: true,
      });
    });
  }

  render() {
    const { DataisLoaded } = this.state;
    const a = this.state.items;

    const b = this.state.total;

    const links = this.state.restaurent;
    const outlets = this.state.restaurent_outlet;
    const user = localStorage.getItem("user");
    const user_data = JSON.parse(user);
    this.restro_id = user_data.restro_id;

    const dates = new Date();
    const month = JSON.stringify(dates.getMonth() + 1);
    const date = JSON.stringify(dates.getDate());
    const year = JSON.stringify(dates.getFullYear());
    const recent_date = month + "-" + date;

    const columns = [
      {
        selector: (row) => row.name,
        cellExport: (row) => row.name,
        sortable: true,
      },
      {
        selector: (row) => row.email,
        cellExport: (row) => row.email,
        omit: true,
        sortable: true,
      },
      {
        selector: (row) => row.mobile,
        cellExport: (row) => row.mobile,
        sortable: true,
      },
      {
        selector: (row) => row.message,
        cellExport: (row) => row.message,
        omit: true,
        sortable: true,
      },
      {
        selector: (row) => row.business_location,
        cellExport: (row) => row.business_location,
        sortable: true,
        omit: true,
      },
      {
        selector: (row) => row.budget,
        cellExport: (row) => row.budget,
        sortable: true,
      },
      {
        selector: (row) => row.restro_name,
        cellExport: (row) => row.restro_name,
        sortable: true,
      },
      {
        selector: (row) => row.utm_campaign,
        cellExport: (row) => row.utm_campaign,
        omit: true,
      },
      {
        selector: (row) => row.utm_medium,
        cellExport: (row) => row.utm_medium,
        omit: true,
      },
      {
        selector: (row) => row.utm_source,
        cellExport: (row) => row.utm_source,
        omit: true,
      },
      {
        selector: (row) =>
          row.created_at == "CREATED AT"
            ? "CREATED AT"
            : moment(row.created_at).format("DD-MM-YY HH:mm:ss"),
        cellExport: (row) =>
          row.created_at == "CREATED AT"
            ? "CREATED AT"
            : moment(row.created_at).format("DD-MM-YY HH:mm:ss"),
        sortable: true,
      },
    ];

    const onSubmit = async (e) => {
      this.filterfetch(e);
    };

    const ExpandedComponent =
      (suppData) =>
      ({ data }) => {
        return (
          <>
            <div className="row px-5 mt-2">
              <div className="col-md-6">
                <mat-card>
                  <table>
                    <tr>
                      <th className="w-100">Name</th>
                      <td>{data.name}</td>
                    </tr>
                    <tr>
                      <td colSpan="2">
                        <hr />
                      </td>
                    </tr>

                    <tr>
                      <th>Email</th>
                      <td>{data.email}</td>
                    </tr>
                    <tr>
                      <td colSpan="2">
                        <hr />
                      </td>
                    </tr>

                    <tr>
                      <th>Mobile</th>
                      <td>{data.mobile}</td>
                    </tr>
                    <tr>
                      <td colSpan="2">
                        <hr />
                      </td>
                    </tr>

                    <tr>
                      <th>Budget</th>
                      <td>{data.budget}</td>
                    </tr>
                    <tr>
                      <td colSpan="2">
                        <hr />
                      </td>
                    </tr>

                    <tr>
                      <th>Business Location</th>
                      <td>{data.business_location}</td>
                    </tr>
                    <tr>
                      <td colSpan="2">
                        <hr />
                      </td>
                    </tr>

                    <tr>
                      <th>Message</th>
                      <td>{data.message}</td>
                    </tr>
                    <tr>
                      <td colSpan="2">
                        <hr />
                      </td>
                    </tr>

                    <tr>
                      <th>Restaurant</th>
                      <td>{data.restro_name}</td>
                    </tr>
                    <tr>
                      <td colSpan="2">
                        <hr />
                      </td>
                    </tr>

                    <tr>
                      <th>Utm_Source</th>
                      <td>{data.utm_source}</td>
                    </tr>
                    <tr>
                      <td colSpan="2">
                        <hr />
                      </td>
                    </tr>

                    <tr>
                      <th>Utm_Medium</th>
                      <td>{data.utm_medium}</td>
                    </tr>
                    <tr>
                      <td colSpan="2">
                        <hr />
                      </td>
                    </tr>

                    <tr>
                      <th>utm_Campaign</th>
                      <td className="text-nowrap">{data.utm_campaign}</td>
                    </tr>
                  </table>
                </mat-card>
              </div>
            </div>
            {suppData}{" "}
          </>
        );
      };

    const bFilter = async () => {
      if (!this.start_date && !this.end_date && !this.rest) {
        alert("Please Select Any Filter");
        return;
      }

      if (this.start_date && !this.end_date) {
        alert("Please select end date");
        return;
      }

      if (this.end_date && !this.start_date) {
        alert("Please select start date");
        return;
      }

      const end_date = this.end_date;
      const start_date = this.start_date;
      const page = this.state.page;
      const per_page = this.state.per_page;

      let a = localStorage.getItem("user");
      let b = JSON.parse(a);
      let user_id = b.id;
      let restro_id = b.restro_id;
      const rest = this.rest !== undefined ? this.rest : "";

      if (restro_id === 0) {
        restro_id = rest;
      }

      axios
        .post(endpoints.franchiseFilter, {
          start_date,
          end_date,
          restro_id,
          page,
          per_page,
        })
        .then((response) => {
          this.setState({
            items: response.data.data,
            totalfranchise: response.data.total,
            totalPages: response.data.total_pages,
            DataisLoaded: true,
          });
        });
    };

    const onStartChange = (e) => {
      this.start_date = e.target.value;
    };
    const onEndChange = (e) => {
      this.end_date = e.target.value;
    };

    const onRestChange = (e) => {
      this.rest = e.target.value;
    };
    const c = [
      {
        name: "NAME",
        email: "EMAIL",
        mobile: "NUMBER",
        message: "MESSAGE",
        business_location: "LOCATION",
        budget: "BUDGET",
        restro_name: "RESTAURANT",
        utm_campaign: "UTM_CAMPAIGN",
        utm_medium: "UTM_MEDIUM",
        utm_source: "UTM_SOURCE",
        created_at: "CREATED AT",
      },
    ];

    const data = c.concat(a);
    const tableData = {
      columns,
      data,
    };

    if (!DataisLoaded)
      return (
        <div className="spinner">
          <InfinitySpin
            visible={true}
            width="200"
            color="#fbaa1a"
            ariaLabel="infinity-spin-loading"
          />
        </div>
      );

    return (
      <>
        <h2>Franchise Leads</h2>
        <Card className="px-3 py-3">
          <form
            className="ui form"
            onSubmit={(e) => onSubmit(e)}
            encType="multipart/form-data"
          >
            <div className="row">
              <div className="col-md-3">
                <label>Start Date</label>
                <br />
                <TextField
                  fullWidth
                  id="start_date"
                  label="Start Date"
                  type="date"
                  name="start_date"
                  place="Start Date"
                  onChange={(e) => onStartChange(e)}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onKeyDown={(e) => e.preventDefault()}
                />
              </div>
              <div className="col-md-3">
                <label>End Date</label>
                <br />
                <TextField
                  fullWidth
                  id="end_date"
                  label="End Date"
                  type="date"
                  name="end_date"
                  place="End Date"
                  onChange={(e) => onEndChange(e)}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onKeyDown={(e) => e.preventDefault()}
                />
              </div>

              {this.restro_id === 0 ? (
                <div className="col-md-3">
                  <label>Restaurant</label>
                  <select
                    name="rest"
                    required
                    className="form-control"
                    onChange={(e) => onRestChange(e)}
                  >
                    <option value="">Select Restaurant</option>
                    {links.map((e, key) => {
                      return (
                        <option key={key} value={e.id}>
                          {e.name}
                        </option>
                      );
                    })}
                  </select>
                </div>
              ) : (
                ""
              )}
              <div className="col col-3">
                <div className="mt-5 text-center">
                  <Button
                    className="w-50"
                    onClick={() => bFilter()}
                    style={{ color: "white" }}
                    variant="contained"
                    size="medium"
                  >
                    Filter
                  </Button>
                </div>
              </div>
            </div>
          </form>
        </Card>
        <div className="row mt-2">
          <DataTableExtensions {...tableData} filter={false}>
            <DataTable
              defaultSortField="id"
              pagination
              paginationServer
              highlightOnHover
              paginationTotalRows={this.state.totalfranchise}
              onChangePage={this.handlePageChange}
              onChangeRowsPerPage={this.handlePerRowsChange}
              progressPending={!this.state.DataisLoaded}
              expandableRows
              expandableRowsComponent={ExpandedComponent()}
            />
          </DataTableExtensions>
        </div>
      </>
    );
  }
}
export default withRouter(FranchiseLeads);
